<template>
  <div class="dashboard">
    <top-header></top-header>
    <b-container fluid class="mb-4" style="margin-top:4%">
      <b-row>
        <b-col class="px-0">
          <b-img v-if="customer.role == TYPE_SELLER" v-bind="mainProps" class="d-none d-sm-block" src="https://www.alluraa.com/media/images/banner-seller.jpg" fluid></b-img>
          <!-- <b-img v-if="customer.role == TYPE_SELLER" v-bind="mainProps" class="d-block d-sm-none " src="https://www.alluraa.com/media/images/banner-seller-mobile.jpg" fluid></b-img> -->
          <b-img v-if="customer.role == TYPE_ADVICER" v-bind="mainProps" class="d-none d-sm-block" src="https://www.alluraa.com/media/images/banner-sales-advisor.jpg" fluid></b-img>
          <b-img v-if="customer.role == TYPE_ADVICER" v-bind="mainProps" class="d-block d-sm-none" src="https://www.alluraa.com/media/images/banner-sales-advisor-mobile.jpg" fluid></b-img>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mb-3">
      <b-row>
        <b-col cols="12" md="6" class="px-2 text-left d-none d-md-block">
          <div class="heading mb-4">How it works:</div>
          <div v-if="customer.role == TYPE_SELLER">
            <b-media class="mb-4" tag="li"> <!-----------SELLER -------------->
              <template v-slot:aside>
                <b-img src="../assets/icon-catalog.png" v-bind="iconImg" fluid alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Create Your Catalog</p>
              <p class="mb-0 mt-2">
                List the products you want to sell on the website, with the help of our team.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-growth.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Maximize Your Brand Reach</p>
              <p class="mb-0 mt-2">
                Once the products are listed, our dedicated influencer spread across the country will share your products through different social media platforms.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-payment.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Start Earning</p>
              <p class="mb-0 mt-2">
                Get assured hassle-free payments in your preferred bank account within a few days of successfully delivering the order.
              </p>
            </b-media>
          </div>
          <div v-else> <!-----------SALES ADVISOR -------------->
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-search.png" v-bind="iconImg" fluid alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Search</p>
              <p class="mb-0 mt-2">
                Explore a variety of high-quality products across different categories.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-share.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Share</p>
              <p class="mb-0 mt-2">
                Share the product images and videos with your customers through Whatsapp, Facebook and Instagram.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-payment.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Earn money</p>
              <p class="mb-0 mt-2">
                Get profit margins and bonuses directly to your bank account every week.
              </p>
            </b-media>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="px-3 text-left">
          <div class="heading mb-4" v-if="customer.role == TYPE_SELLER">Expand Your Brand Reach!</div>
          <div class="heading mb-4" v-else>Start earning today!</div>
          <div class="boxshadow p-4 submit-form">
            <b-alert :show="form_alert.length > 0" variant="warning">
              <p class="py-0 my-0" v-for="txt in form_alert" :key="txt">{{txt}}</p>
            </b-alert>
           <!-- <b-form >@submit="onSubmit" @reset="onReset"-->
               <form ref="form" @submit.stop.prevent="handleSubmitSalseadv">
              <b-row>
                <b-col cols="3" xs="3" sm="2" md="3" lg="2" class="pr-1">
                  <b-form-select v-model="customer.prefix" class="mb-3">
                    <b-form-select-option value="mr">Mr.</b-form-select-option>
                    <b-form-select-option value="mrs">Ms.</b-form-select-option>
                    <b-form-select-option value="dr">Dr.</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col class="pl-1">
                   <b-form-group label-for="fullnameSa-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerState.fullname" invalid-feedback="Full Name is required!" >
                            <b-form-input id="fullnameSa-input" :state="customerState.fullname" v-model="customer.fullname" placeholder="*Full Name" @focusin="customerState.fullname = null"></b-form-input>
                        </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col>
                 
                  <b-form-group label-for="mobileSa-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerState.mobile" invalid-feedback="Mobile No is required!" >
                            <b-form-input type="tel" id="mobileSa-input" :state="customerState.mobile" v-model="customer.mobile" placeholder="*Mobile No." @focusin="customerState.mobile = null" maxlength="10"></b-form-input>
                        </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-0 mb-3">
                <b-col>
                  <b-form-group :state="customerState.email"  label-for="emailSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
                            <b-form-input id="emailSa-input" v-model="customer.email" :state="customerState.email" placeholder="*Email" @focusin="customerState.email = null"></b-form-input>
                        </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-0 mb-3">
                <b-col>
                  <!--span>
                    <b-form-select v-model="customer.location" required>
                      <b-form-select-option value="" hidden selected placeholder="select State">*Select State</b-form-select-option>
                      <b-form-select-option v-for="option in states" :key="option" :value="option">{{option}}</b-form-select-option>
                    </b-form-select>
                  </span> -->
                  <b-form-group :state="customerState.location"  label-for="locationSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="location is required!">
                    <b-form-select v-model="customer.location" id="locationSa-input" :state="customerState.location" v-on:change="customerState.location = null">
                      <b-form-select-option value="" hidden selected placeholder="select State">*Select State</b-form-select-option>
                      <b-form-select-option v-for="option in states" :key="option" :value="option">{{option}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-0 mb-3">
                <b-col>
                  <!-- span>
                    <b-form-select v-model="customer.workarea" required>
                      <b-form-select-option value="" hidden selected v-if="customer.role == TYPE_SELLER">*Explore Category</b-form-select-option>
                      <b-form-select-option value="" hidden selected v-else>*Select Work Area</b-form-select-option>
                      <b-form-select-option v-for="option in workarea_options" :key="option" :value="option">{{option}}</b-form-select-option>
                    </b-form-select>
                  </span> -->
                  <b-form-group :state="customerState.workarea"  label-for="workareaSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Work Area is required!">
                    <b-form-select v-model="customer.workarea" id="workareaSa-input" :state="customerState.workarea" v-on:change="customerState.workarea = null">
                      <b-form-select-option value="" hidden selected v-if="customer.role == TYPE_SELLER">*Explore Category</b-form-select-option>
                      <b-form-select-option value="" hidden selected v-else>*Select Work Area</b-form-select-option>
                      <b-form-select-option v-for="option in workarea_options" :key="option" :value="option">{{option}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-0 mb-3" v-if="customer.workarea == 'Other'">
                <b-col>
                  <span><b-form-input v-model="customer.other" :placeholder="(customer.role == TYPE_SELLER)?'Add your category':'Add your work area'"></b-form-input></span>
                </b-col>
              </b-row>
              <!--<b-row class="terms">
                <b-col>
                  <b-form-checkbox v-model="terms_condition" name="checkbox-1" value="accepted" unchecked-value="not_accepted">
                    <span>By checking this box, I agree to receive emails from Alluraa.</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>-->
              <b-row>
                <b-col class="text-center">
                  <!-- <b-link class="button btn-solid" @click="submitRegistration()">Submit</b-link> -->
                  <b-button type="submit" variant="primary" class="mr-2 btn-solid">Submit</b-button>
                </b-col>
              </b-row>
            <!-- </b-form>-->
          </form>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="px-3 pt-3 text-left d-block d-sm-block d-md-none">
          <!--<div class="heading">How it works:</div>
          <b-media class="mb-4" tag="li">
            <template v-slot:aside>
              <b-img src="../assets/icon-catalog.png" v-bind="iconImg" fluid alt="placeholder"></b-img>
            </template>
            <p class="mt-0 media-title">Create Your Catalog</p>
            <p class="mb-0 mt-2" v-if="customer.role == 'seller'">
              List the products you want to sell on the website, with the help of our team.
            </p>
          </b-media>
          <b-media class="mb-4" tag="li">
            <template v-slot:aside>
              <b-img src="../assets/icon-growth.png" v-bind="iconImg" alt="placeholder"></b-img>
            </template>
            <p class="mt-0 media-title">Maximize Your Brand Reach</p>
            <p class="mb-0 mt-2">
              Once the products are listed, our dedicated influencer spread across the country will share your products through different social media platforms.
            </p>
          </b-media>
          <b-media class="mb-4" tag="li">
            <template v-slot:aside>
              <b-img src="../assets/icon-payment.png" v-bind="iconImg" alt="placeholder"></b-img>
            </template>
            <p class="mt-0 media-title">Start Earning</p>
            <p class="mb-0 mt-2">
              Get assured hassle-free payments in your preferred bank account within a few days of successfully delivering the order.
            </p>
          </b-media>-->
          <div class="heading mb-4">How it works:</div>
          <div v-if="customer.role == TYPE_SELLER">
            <b-media class="mb-4" tag="li"> <!-----------SELLER -------------->
              <template v-slot:aside>
                <b-img src="../assets/icon-catalog.png" v-bind="iconImg" fluid alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Create Your Catalog</p>
              <p class="mb-0 mt-2">
                List the products you want to sell on the website, with the help of our team.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-growth.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Maximize Your Brand Reach</p>
              <p class="mb-0 mt-2">
                Once the products are listed, our dedicated influencer spread across the country will share your products through different social media platforms.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-payment.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Start Earning</p>
              <p class="mb-0 mt-2">
                Get assured hassle-free payments in your preferred bank account within a few days of successfully delivering the order.
              </p>
            </b-media>
          </div>
          <div v-else> <!-----------SALES ADVISOR -------------->
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-search.png" v-bind="iconImg" fluid alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Search</p>
              <p class="mb-0 mt-2">
                Explore a variety of high-quality products across different categories.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-share.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Share</p>
              <p class="mb-0 mt-2">
                Share the product images and videos with your customers through Whatsapp, Facebook and Instagram.
              </p>
            </b-media>
            <b-media class="mb-4" tag="li">
              <template v-slot:aside>
                <b-img src="../assets/icon-payment.png" v-bind="iconImg" alt="placeholder"></b-img>
              </template>
              <p class="mt-0 media-title">Earn money</p>
              <p class="mb-0 mt-2">
                Get profit margins and bonuses directly to your bank account every week.
              </p>
            </b-media>
          </div>  
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mb-3">
      <b-row>
        <b-col class="px-2 text-left">
          <div class="heading">#MyshopMybusiness</div>
        </b-col>
      </b-row>
      <b-row>
	    <b-col>
		<instagram-swiper :products="instagramfeed"></instagram-swiper>
		</b-col>
		
		</b-row>
		<!-- <b-row>
        <b-col cols="6" sm="6" lg="3" class="p-2 text-left" v-for="(data,index) in instagramfeed" :key="index">
          <template v-if="index < feedindex">
            <b-link :href="data.url"><b-img v-bind="socialImg" :src="data.thumbnailUrl" fluid></b-img></b-link>
          </template>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <b-link class="button btn-solid" v-show="feedindex < instagramfeed.length" @click="feedindex += 2">Load more</b-link>
        </b-col>
      </b-row> -->
    </b-container>
    <b-container class="my-2">
      <b-row>
        <b-col class="px-2 text-left">
          <div class="heading">About our team</div>
        </b-col>
      </b-row>
    </b-container>
    <div class="about-team bg-linear pt-5 pb-3">
      <b-container class="px-2 py-2">
        <b-row>
          <b-col class="px-3 text-left">
            <div ref="rpswiper" v-swiper:mySwiper="swiperOption" class="px-5">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="usr.id" v-for="usr in team">
                        <div class="swiper-text p-0">
                            <!--<p class="pt-2 px-3 font-xl text-center q"><q><span>{{usr.text}}</span></q></p>
                            <p class="font-xl text-center"><span>{{usr.name}}</span></p>-->
                            <b-img :src="usr.img" fluid></b-img>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination" slot="pagination"></div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <bottom-footer></bottom-footer>
    <b-modal id="modal-status" hide-footer>
      <template v-slot:modal-title>
        Status
      </template>
      <div class="d-block text-center">
        <h5>{{modal.msg}}</h5>
      </div>
      <b-link class="mt-3 button btn-solid float-right" @click="$bvModal.hide('modal-status')">Close Me</b-link>
    </b-modal>

    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
//import Footer from "@/components/footer-promo.vue";
import Footer from "@/components/footer.vue";
import InstagramSwiper from "@/components/instagram-swiper.vue";

export default {
  name: "Home",
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
	"instagram-swiper": InstagramSwiper,
  },
  mounted(){
	
    /*let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
    document.head.appendChild(recaptchaScript);

    let s1 = document.createElement('script');
    s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
    document.head.appendChild(s1);*/
      
		this.init();
	},
  data() {
    return {
	  recordUrlInsta: this.$root.NEWAPIURL+'profileapi/loadinsta',
      urlSellerReg:this.$root.WEBURL+'registration',
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: '',
        other:''
      },
      customerState:{
      fullname:null,
      mobile:null,
      email:null,
      location:null,
      workarea:null,
      other:null
      },
      team:[
        {id:1, img:'https://www.alluraa.com/media/images/quote-1.png', name:'Mr. Vijay Shanker', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that give people further confidence in e-commerce platforms potential.'},
        {id:2, img:'https://www.alluraa.com/media/images/quote-2.png', name:'Mr. Bhanu Mishra', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to empower people from across the country to become entrepreneurs and make a living.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['House Maker','Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Fashion','Cosmetics','Electronics','Herbal Products','Organic Food','Toys & baby','Home Essentials','Indian Crafts','Other'],
      workarea_options: [],
      mainProps: { fluidGrow: true, class: 'm1' },
      mainblankProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 100, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { width: 300, height: 300, fluidGrow: true, class: 'm1' },
      instagramfeed: [],
      feedindex: 4,
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 60
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 80
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      }
    }
  },
  methods: {
    checkFormValiditySalseadv() {
      var valid = true; 
      if(this.customer.fullname.length < 3){
      valid = false;
      this.customerState.fullname = false;
      }else{
      this.customerState.fullname= true;
      }
      if(this.customer.mobile.length < 10){
      valid = false;
       this.customerState.mobile = false;
      }else{
      this.customerState.mobile = true;
      }
      if(!this.validateemail(this.customer.email)){
          valid = false;
          this.customerState.email = false;
        }else{
          this.customerState.email = true;
        }

     if(this.customer.location==''){
         valid = false;
          this.customerState.location = false;      
      }else{
      this.customerState.location = true;
      }

      if(this.customer.workarea==''){
         valid = false;
          this.customerState.workarea = false;      
      }else{
      this.customerState.workarea = true;
      }
      return valid;
      },
      handleSubmitSalseadv(){
        if (!this.checkFormValiditySalseadv()) {
        return;
        }
        //alert('Test');
       // return false;
        var self = this;


        var workarea = '';
        if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
        }else{
        workarea = self.customer.workarea;
        }

        var o = {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: 'seller',
        location: self.customer.location,
        workarea: workarea
        }


        self.axios.post(self.urlSellerReg, o).then(function (response) {
        if(response.data.error == 0 || response.data.error == '0'){
        self.$bvToast.toast(response.data.message, {
          title: 'Register',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          appendToast: true
        });
        //self.$root.flash_msg.msg = response.data.message;
         /* self.$session.remove('share_user_id');
          self.$bvModal.hide('customerSeller-modal');*/
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.customerState = {
            fullname:null,
            mobile:null,
            email:null,
            workarea:null,
            location:null,
            other:null
          };
		  self.$router.push('/marketing/seller/thanks');
          //self.$bvModal.show('modal-status');

          
        }else{
        self.error_msg = response.data.message;
        self.$bvToast.toast(response.data.message, {
          title: 'Register',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          appendToast: true
        });
        }
        })
        .catch(function (error) {
        alert(error);
        });
      },
    handleResize(){
      var self  = this;
      //this.window.width = window.innerWidth;
      //this.window.height = window.innerHeight;
      if(window.innerWidth < 700){
        self.feedindex = 2;
      }
    },
    init(){
      var self = this;
      if(self.$route.params.param_role){
        self.customer.role = self.$route.params.param_role;
      //  self.customer.workarea = self['workarea_'+self.$route.params.param_role];
      }
      //alert(self.customer.role.replace('-',''));
      self.workarea_options = self['workarea_'+self.customer.role.replace('-','')];

      //window.addEventListener('resize', self.handleResize);
      self.handleResize();
	  
	  /*InstaGram From DB*/
			/*self.axios.post(self.recordUrlInsta, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    var tmp = response.data.result;
					console.log('InstaImage'+tmp);
					self.instagramfeed = tmp;
					
                    //self.loading = false;
				}else {
					//self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			}); */
			/* -------------------- */

      
	/*
      const instagramRegExp = new RegExp(/<script type="text\/javascript">window\._sharedData = (.*);<\/script>/)

      const fetchInstagramPhotos = async (accountUrl) => {
        const response = await self.axios.get(accountUrl)
        const json = JSON.parse(response.data.match(instagramRegExp)[1])
        const edges = json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 12)
        const photos = edges.map(({ node }) => {
          return {
            url: `https://www.instagram.com/p/${node.shortcode}/`,
            thumbnailUrl: node.thumbnail_src,
            displayUrl: node.display_url,
            caption: node.edge_media_to_caption.edges[0].node.text
          }
        })
        return photos
      }

      (async () => {
        try {
          self.instagramfeed = await fetchInstagramPhotos('https://www.instagram.com/alluraaTech/');
          
          
        } catch (e) {
          console.error('Fetching Instagram photos failed', e)
        }
      })() */

      //self.customer.workarea = 
      //alert(self['workarea_'+self.customer.role]);
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
    submitRegistration(){
      var self = this;
      var valid = true;
      self.form_alert = [];
      if(self.customer.fullname == ''){
        //self.form_alert.push("Full name is required!");
        valid = false;
      }
      if(self.customer.email == '' && self.customer.mobile == '' ){
        //self.form_alert.push("Email or mobile is required!");
        valid = false;
      }
      /*if(self.terms_condition == 'not_accepted'){
        //self.modal.msg = "Please accept terms and condition!";
        //self.$bvModal.show('modal-status');
        self.form_alert.push("Terms and condition is required!");
        valid = false;
        //return;
      }*/
      var mobile = self.customer.mobile;
      if(mobile.length < 10){
        self.form_alert.push('Please add a valid mobile number.');
        valid = false;
      }
      if(self.customer.workarea == ''){
        valid = false;
      }
      
      if(!self.validateemail(self.customer.email)){
        self.form_alert.push('Please add a valid email.');
        self.form_alert.push('All fields are mandatory.');
        valid = false;
      }else{
        console.log('Valid email format.!');
      }

      if(valid == false){
        return;
      }

      var workarea = '';
      if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
      }else{
        workarea = self.customer.workarea;
      }
      
			self.axios.post(self.$root.WEBURL+'registration', {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: self.customer.role,
        location: self.customer.location,
        workarea: workarea
			})
			.then(function (response) {
        
				if(response.data.error == 0 || response.data.error == '0'){
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.$bvModal.show('modal-status');
				}else if(response.data.error == 1){
          self.modal.msg = "Registration Failed! Try agin later!";
					self.$bvModal.show('modal-status');
				}else if(response.data.error == 2){
          self.modal.msg = "Registration Failed! Email or mobile allready exist!";
					self.$bvModal.show('modal-status');
				}
			})
			.catch(function (error) {
				alert(error);
			});
    }
  },
	metaInfo() {
		return{
			title: 'Seller | Alluraa',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'Seller Advisor' },
				{ name: 'description', content: 'Seller | Alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
